import {
  ApiVersions,
  CashierConfigurationKeys,
  ColourThemes,
  Directions,
  PaymentTypes,
  SubmitInitiators,
  UiVersions,
} from '@cashier/cashier-model';

import { convertToLocale } from '../../helpers';

export interface Configuration {
  amount: string | null;
  bonus: string | null;
  country: string | null;
  customerBalance: string | null;
  currency: string | null;
  direction: Directions;
  host: string | null;
  initialAmount: string | null;
  language: string | null;
  location: string;
  merchantId: string | null;
  orderId: string | null;
  paymentMethod: string | null;
  paymentType: PaymentTypes | null;
  platform: string | null;
  sessionId: string | null;
  submitInitiator: SubmitInitiators;
  termsUrl: string | null;
  theme: ColourThemes;
  userId: string | null;
  webView: boolean;
  apiVersion: ApiVersions;
  uiVersion: UiVersions;
}

export const ConfigurationExtractor = {
  fromRequestUri: (): Configuration => {
    const queryParams = new URLSearchParams(window.location.search);

    const getParam = (
      key: CashierConfigurationKeys,
      defaultValue?: string,
    ): string | null => queryParams.get(key.toString()) || defaultValue || null;

    return {
      paymentMethod: getParam(CashierConfigurationKeys.PaymentMethod),
      paymentType: getParam(CashierConfigurationKeys.PaymentType)
        ? (getParam(CashierConfigurationKeys.PaymentType) as PaymentTypes)
        : null,
      bonus: getParam(CashierConfigurationKeys.Bonus),
      currency: getParam(CashierConfigurationKeys.Currency),
      host: getParam(CashierConfigurationKeys.Host),
      language:
        convertToLocale(
          getParam(CashierConfigurationKeys.Language, '') as string,
        ) || null,
      location: window.location.origin,
      merchantId: getParam(CashierConfigurationKeys.MerchantId),
      platform: getParam(CashierConfigurationKeys.Platform),
      sessionId: getParam(CashierConfigurationKeys.SessionId),
      termsUrl: getParam(CashierConfigurationKeys.TermsUrl),
      userId: getParam(CashierConfigurationKeys.UserId),
      customerBalance: getParam(CashierConfigurationKeys.CustomerBalance),
      webView: 'true' === getParam(CashierConfigurationKeys.WebView),
      direction: getParam(
        CashierConfigurationKeys.Direction,
        Directions.Ltr,
      ) as Directions,
      country: getParam(CashierConfigurationKeys.Country),
      orderId:
        getParam(CashierConfigurationKeys.OrderId) &&
        getParam(CashierConfigurationKeys.OrderId) !== 'null'
          ? getParam(CashierConfigurationKeys.OrderId)
          : null,
      amount:
        getParam(CashierConfigurationKeys.Amount) &&
        getParam(CashierConfigurationKeys.Amount) !== 'null'
          ? getParam(CashierConfigurationKeys.Amount)
          : null,
      initialAmount: getParam(CashierConfigurationKeys.InitialAmount),
      theme: getParam(
        CashierConfigurationKeys.Theme,
        ColourThemes.Dark,
      ) as ColourThemes,
      submitInitiator: getParam(
        CashierConfigurationKeys.SubmitInitiator,
        SubmitInitiators.Self,
      ) as SubmitInitiators,
      apiVersion: getParam(
        CashierConfigurationKeys.ApiVersion,
        ApiVersions.v1,
      ) as ApiVersions,
      uiVersion: getParam(
        CashierConfigurationKeys.UiVersion,
        UiVersions.v1,
      ) as UiVersions,
    };
  },
};
